import styled from "styled-components";

export const Container = styled.div`
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
